import { useState } from 'react';
import {
    Grid,
    Button,
    Divider
} from '@mui/material';
import RofBatchData from './RofBatchData';
import { useSelector } from 'react-redux';
import RofBatchMedia from './RofBatchMedia';

export default function RofProduction() {
    const [selectedCategory, setSelectedCategory] = useState('Batch Data');
    const { selectedProject } = useSelector(state => state.postFormData);
    const { id, measureType } = selectedProject || {}

    const ROF_PRODUCTION_CATEGORIES = [
        'Batch Data',
        'Batch Media',
    ];

    return (
        <Grid container gap={3}>
            <Grid item xs={12} sx={{ display: 'flex', gap: 2 }}>
                {ROF_PRODUCTION_CATEGORIES.map((productionCategory, index) => (
                    <Button
                        key={index}
                        onClick={() => setSelectedCategory(productionCategory)}
                        variant={selectedCategory === productionCategory ? 'contained' : 'outlined'}
                    >
                        {productionCategory}
                    </Button>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
                {
                    selectedCategory === 'Batch Data' &&
                    <RofBatchData projectKey={id} measureType={measureType} />
                }
                {
                    selectedCategory === 'Batch Media' &&
                    <RofBatchMedia projectKey={id} />
                }
            </Grid>
        </Grid>
    );

}


